<template>
  <div  id="font-size"
        @click.stop="show">
    <img src="../assets/fontsize.png">
    <ul class="font-size-list"
        ref="fontSizeList">
      <li
        v-for="(value, key) in fontSizeMap"
        @mouseenter="leaveUl(key)"
        :key="`font-size-btn-${value}`"
        :class="{ current: key === stickFontSize }"
      >
        {{value}}
      </li>
    </ul>
  </div>
</template>

<script>
// 依赖的外部类库
import {
  mapState,
  mapMutations
} from 'vuex'
import {
  UPDATE_FONTSIZE
} from '../store/mutation-type'
const fontSizeMap = {
  '80px': '初号',
  '70px': '一号',
  '62px': '二号',
  '54px': '小二',
  '46px': '三号',
  '40px': '小三',
  '34px': '四号',
  '28px': '小四',
  '24px': '五号',
  '20px': '小五'
}
export default {
  name: 'FontSizeBtn',
  data () {
    return {
      fontSizeMap,
      stickFontSize: ''
    }
  },
  computed: {
    ...mapState(['fontSize'])
  },
  watch: {
    fontSize: (() => {
      let tag = true
      return function (newVal) {
        if (tag) {
          this.stickFontSize = newVal
          tag = false
        }
      }
    })()
  },
  methods: {
    ...mapMutations({ // vuex中的mutation混合
      updateFontSize: UPDATE_FONTSIZE
    }),
    leaveUl (fontSize) {
      this.stickFontSize = fontSize
      this.updateFontSize(fontSize)
      this.$socket.emit('config', {fontSize})
    },
    show () { // 字体栏动态显示隐藏
      this.$emit('isPopBox', true)
      let listEle = document.querySelector('.font-size-list')
      if (!listEle.style.opacity || listEle.style.opacity === '0') { // 显示
        listEle.style.display = 'block'
        setTimeout(() => {
          this.$emit('isPopBox', false)
          listEle.style.opacity = 1
          listEle.style.transform = 'translate(0, 10px)'
        })
      } else { // 隐藏
        listEle.style.opacity = 0
        listEle.style.transform = 'translate(0, 0px)'
        setTimeout(() => {
          this.$emit('isPopBox', false)
          listEle.style.display = 'none'
        }, 300)
      }
    }
  }
}
</script>

<style scoped="scoped">
#font-size>img{
  margin-top:8px;
  width: 36px;
}
.font-size-list {
  display: none;
  position: absolute;
  left: 124px;
  top: 60px;
  width: 80px;
  z-index: 20;
  background: #ffffff;
  border-radius: 10px;
  font-size: 15px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.20);
  transition: all 0.3s linear 0s;
}
.font-size-list:before{
  content: "";
  display: block;
  position: absolute;
  left: 10px;
  top: -20px;
  width:0;
  height:0;
  border:10px solid transparent;
  border-bottom-color: #f0f0f0;
}
.font-size-list:after{
  content: "";
  display: block;
  position: absolute;
  left: 10px;
  top: -19px;
  width:0;
  height:0;
  border: 10px solid transparent;
  border-bottom-color: #ffffff;
}
.font-size-list li {
  cursor: pointer;
  text-align: center;
  padding-bottom: 15px;
  letter-spacing: 2px;
  color: #838383;
}
.font-size-list li:first-child{
  padding-top: 20px;
}
.font-size-list li.current{
  font-weight: bold;
  color: #444444;
}

</style>



// WEBPACK FOOTER //
// src/components/FontSizeBtn.vue